export default {
  'label/agenda': 'Agenda',
  'label/patients': 'Pacientes',
  'label/reports': 'Relatórios',
  'label/settings': 'Ajustes',
  // A tab or link closed to an account without an active subscription (it opens Meu plano)
  'label/closed_tab': '{0} (disponível quando a assinatura estiver ativa)',
  'label/support': 'Suporte',
  'label/help': 'Ajuda',
  'label/remaining_trial_days': 'dias para testar grátis',
  'action/see_details': 'Ver detalhes',
  'action/reload': 'Atualizar',
  'action/click_to_resolve': 'Clique aqui para resolver',
  'action/logout': 'Sair do Doutore',
  'label/account_will_be_canceled': 'A sua conta será cancelada em breve.',
  'label/payment_problem': 'Não recebemos o pagamento do Doutore.',
  'label/online_support': 'Suporte Online',
  'label/dashboard': 'Painel de Controle',
  'label/beta_app': 'Versão Beta',
};
